export default __webpack_public_path__ + "static/media/desktop.20fd3dc1.ini";